import { z } from 'zod';

import type { FetchAvailabilitiesParams } from 'reservations/availabilities/types';
import { NEXTABLE_AVAILABILITIES_ENDPOINT } from 'reservations/base/constants/endpoints';
import { buildQueryParamString } from 'reservations/base/helpers/buildBentoboxApiEndpoint';
import { restClient } from 'utility/restClient';

const PartySize = z.object({
  size: z.number(),
  status: z.number()
});
type PartySize = z.infer<typeof PartySize>;

const Slot = z.object({
  time24: z.string(),
  time12: z.string(),
  time: z.string(),
  status: z.number(),
  partySizes: z.array(PartySize)
});
type Slot = z.infer<typeof Slot>;

const Availability = z.object({
  date: z.string(),
  slots: z.array(Slot).nullish(),
  status: z.number()
});
type Availability = z.infer<typeof Availability>;

const GetAvailabilities = z.object({
  id: z.string(),
  slotSize: z.number(),
  page: z.number(),
  pageSize: z.number(),
  timeZone: z.string(),
  is24Hour: z.boolean(),
  availability: z.array(Availability)
});
type GetAvailabilities = z.infer<typeof GetAvailabilities>;

export async function fetchAvailabilities({
  partySize,
  beginDateTime,
  endDateTime,
  apiKey,
  excludeTimeSlots = false,
  includeClosed = true
}: FetchAvailabilitiesParams) {
  const queryParams = buildQueryParamString({
    partySize,
    beginDateTime: beginDateTime,
    endDateTime: endDateTime,
    includeClosed: includeClosed.toString(),
    excludeTimeSlots: excludeTimeSlots.toString()
  });
  const endpoint = `${NEXTABLE_AVAILABILITIES_ENDPOINT}?${queryParams}`;
  const response = await restClient.get(endpoint, { nextableApiKey: apiKey });

  try {
    return GetAvailabilities.parse(response);
  } catch (err) {
    /* istanbul ignore next */
    throw err;
  }
}

export type { GetAvailabilities, Availability, Slot, PartySize };
